export default __webpack_public_path__ + "static/media/uzbekistan.65f351e9.svg";